<template>
    <div class="card px-3 py-2">
        <div class="panel-title">
            <h1 class="heading-medium my-1 mb-3">Market Change</h1>
        </div>
        <table class="table">
            <div class="market-change">
                <i class="fas fa-caret-up" v-if="marketChange > 0"></i>
                <i class="fas fa-caret-down" v-else-if="marketChange < 0"></i>
                {{Math.abs(marketChange) | priceformat}} ppl 
            </div>
        </table>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState('livePrices', ['marketChange', 'refreshSecondsLeft'])
    }
}
</script>

<style lang="scss" scoped>
.market-change {
    font-size: 2.4rem;
    @include media-breakpoint-down(md) {
        font-size: 1.4rem;
    }
    font-weight: 700;
    text-align: center;

    .fas {
        margin-right: 0.2rem;

        &.fa-caret-up {
            color: map-get($theme-colors, primary);
        }

        &.fa-caret-down {
            color: map-get($theme-colors, danger);
        }
    }
}
</style>
